'use strict';

var PluginPrefix = 'DocsCdnRetryPlugin';
/**
 * 插件运行时对象在全局对象下的命名空间
 * 插件运行时对象会被注册到 window[RuntimeNamespace]
 */

var RuntimeNamespace = 'DCR';

exports.PluginPrefix = PluginPrefix;
exports.RuntimeNamespace = RuntimeNamespace;
